export const membersTableConfig = {
  columns: [
    { key: "uid", label: "Member Id", sortable: true },
    { key: "first_name", label: "First Name", sortable: true },
    { key: "last_name", label: "Last Name", sortable: true },
    { key: "email", label: "Email", sortable: true },
  ],
  filters: [
    {
      key: "email",
      label: "Email",
      type: "text" as const,
      default: true,
    },
    {
      key: "first_name",
      label: "First Name",
      type: "text" as const,
    },
    {
      key: "last_name",
      label: "Last Name",
      type: "text" as const,
    },
    {
      key: "gender",
      label: "Gender",
      type: "select" as const,
      filterType: "NUMBER" as const,
      options: [
        { label: "Male", value: 1 },
        { label: "Female", value: 2 },
        { label: "Other", value: 3 },
      ],
    },
  ],
};
